<div class="card mb-0">
  <div class="card-header">
    <span class="fa fa-table"></span> &nbsp; Underwriter
  </div>
  <div class="card-body">
    <div class="row mb-3 align-items-end">
    
      <div class="col-md-4">
        <label class="form-label filter-label text-muted">ALL</label>
        <input class="form-control" placeholder="Search..." [(ngModel)]="searchAll" (input)="applyFilter()" />
      </div>
    
      <div class="col-md-4">
        <label class="form-label filter-label text-muted">Underwriter Name</label>
        <input class="form-control" placeholder="Search..." [(ngModel)]="searchName" (input)="applyFilter()" />
      </div>
    
      <div class="col-md-4">
        <label class="form-label filter-label text-muted">Country</label>
        <input class="form-control" placeholder="Search..." [(ngModel)]="searchCountry" (input)="applyFilter()" />
      </div>
    
    </div>
    <!--Table Rows-->

    <div class="technical-datatable responsive-datatable">
      <ngx-datatable #pbTable class="material" [headerHeight]="tableOptions.HeaderHeight"
        [footerHeight]="tableOptions.FooterHeight" [columnMode]="tableOptions.ColumnMode" [scrollbarH]="true"
        [rowHeight]="tableOptions.RowHeight" [rowClass]="getRowClass" [rows]="rows" id="objectTable"
        [perfectScrollbar]="config" [limit]="10" [selectAllRowsOnPage]="true" (activate)="onRowActivate($event)">
        <ngx-datatable-column name="Action" [headerCheckboxable]="true" [width]="70" [sortable]="false"
          [canAutoResize]="false" [draggable]="false" [resizeable]="false" class="cell-center">
          <ng-template ngx-datatable-cell-template let-row="row">
            <input type="checkbox" (change)="checkboxRowSelect(row)" (click)="$event.stopPropagation()" [(ngModel)]="row.isSelected">
          </ng-template>
        </ngx-datatable-column>
          <ngx-datatable-column name="Underwriter Name" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.UnderwriterName}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Known As" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.UnderwriterKnownAs}}
            </span>
          </ng-template>
        </ngx-datatable-column>

         <ngx-datatable-column name="Country" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.Country}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Market Type" [sortable]="false">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
            <span>
              {{row.MarketType}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Synd/Bureau" [sortable]="false">
        <ng-template ngx-datatable-cell-template let-row="row">
          <span>
            {{ row.Syndicate || row.BureauCode }}
          </span>
        </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
            let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">

            <div>
              <div><strong> {{rowCount}} total</strong></div>
            </div>

            <div>
              <app-datatable-pager [page]="curPage" [visiblePagesCount]="currentVisible" [size]="pageSize"
                [count]="rowCount" [hidden]="false" (change)="pbTable.onFooterPage($event)">
              </app-datatable-pager>
            </div>
            <div style="color: #212529;">
              <div></div>
            </div>
          </ng-template>
        </ngx-datatable-footer>

      </ngx-datatable>

    </div>
  </div>

  <div class="card-footer">
    <div class="text-end">
      <button type="button" (click)="select()" class="btn btn-primary">Select</button>
      <button type="button" class="btn btn-dark ms-2" (click)="close()">Close</button>
    </div>
  </div>
</div>